module.exports = __webpack_public_path__ + "img/sj.069a9ded.png";